import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
}), 'ExpandMoreOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ExpandMoreOutlined.js
// module id = 3444
// module chunks = 2